// app/frontend/pages/FAQ.tsx
import { L2KFAQSection } from "../components/ui/FAQ";
import HybridLayout from "../components/layouts/HybridLayout";
import PageContainer from "../components/layouts/PageContainer";
import { SEO } from "../components/common/SEO";

export default function FAQ() {
  return (
    <>
      <SEO
        title="FAQ - Frequently Asked Questions | Learntokiz 2.0"
        description="Find answers to common questions about Learntokiz, our learning platform for Urbankiz dancing."
      />
      <PageContainer>
        <L2KFAQSection
          title="Frequently Asked Questions"
          subtitle="Everything you need to know about Learntokiz"
          showSearch={true}
          searchPlaceholder="Search FAQs..."
          allowMultiple={true}
          highlightExpanded={true}
        />
      </PageContainer>
    </>
  );
}

FAQ.layout = (page: React.ReactNode) => (
  <HybridLayout hideOnScroll={true}>{page}</HybridLayout>
);
